export const NEW_ASCONA_ID = '7967188d-a5fe-4763-b78a-2952b17b98b4';
export const ARMANI_ID = 'dbafa4e9-283f-4b87-955a-4a783c1e9764';

// UNUSED
// export const SHOPS_WITH_SIZES = [NEW_ASCONA_ID, ARMANI_ID];
